import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { routes } from './app.routes';
import { tokenInterceptor } from './core/interceptors/token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Display report timestamps in North Macedonia's current summer time (CEST).
    // This offset needs to return to +0100 when daylight saving time ends.
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: '+0200' } },
    importProvidersFrom(MatSnackBarModule),
    provideRouter(routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withPreloading(PreloadAllModules),
    ),

    provideHttpClient(
      withInterceptors([
        tokenInterceptor,
      ])
    ),
  ]
};
